exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cron-row {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.cron-row:not(:last-of-type) {\n  margin-bottom: 16px;\n}\n.cron-row .label {\n  width: 100px;\n}\n.cron-row input {\n  width: 100%;\n  height: 48px;\n  margin-left: 11px;\n}\n.schedule-err {\n  margin-left: 112px;\n  color: red;\n}\n", ""]);

// exports
